/**
 * Copyright 2022 Design Barn Inc.
 */

import type { BugsnagPluginReactResult } from '@bugsnag/plugin-react';
import React from 'react';

import Bugsnag from '../../libs/bugsnag';

import GeneralError from './general-error';

const plugin = Bugsnag.getPlugin('react') as BugsnagPluginReactResult;

const BugsnagErrorBoundary = plugin.createErrorBoundary(React);

const Fallback = (): React.ReactElement => {
  return <GeneralError />;
};

const ErrorBoundary = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  return <BugsnagErrorBoundary FallbackComponent={Fallback}>{children}</BugsnagErrorBoundary>;
};

export default ErrorBoundary;
